<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="kiosk-modal-title">
      <div class="modal">
        <h2 id="kiosk-modal-title">Enter Kiosk Mode?</h2>
        <p>This will enable fullscreen and keep the screen awake.</p>
        <div class="modal-actions">
          <button class="btn btn-primary" @click="onYes">Yes</button>
          <button class="btn btn-secondary" @click="onNo">No</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const emit = defineEmits<{
  confirm: [];
  dismiss: [];
}>();

const visible = ref(true);

function onYes() {
  visible.value = false;
  emit('confirm');
}

function onNo() {
  visible.value = false;
  emit('dismiss');
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 1rem;
}

.modal {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  max-width: 360px;
  width: 100%;
  text-align: center;
}

.modal h2 {
  margin: 0 0 0.75rem;
  font-size: 1.4rem;
}

.modal p {
  margin: 0 0 1.5rem;
  color: #555;
}

.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn {
  flex: 1;
  padding: 0.875rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  min-height: 48px;
}

.btn-primary {
  background: #2563eb;
  color: #fff;
}

.btn-secondary {
  background: #e5e7eb;
  color: #111;
}

@media (prefers-color-scheme: dark) {
  .modal {
    background: #1f2937;
    color: #f9fafb;
  }

  .modal p {
    color: #9ca3af;
  }

  .btn-secondary {
    background: #374151;
    color: #f9fafb;
  }
}
</style>
